import PatrolMarker from '@/models/PatrolMarker';
import TableEdges from '@/models/TableEdges';

let markerGroupID = 0;

export default class MarkerGroup {
  constructor(patrolMarkers = [], tableEdge = TableEdges.N, markerCount = 4) {
    markerGroupID += 1;

    this.id = markerGroupID;
    this.patrolMarkers = patrolMarkers;
    this.tableEdge = tableEdge;
    this.markerCount = markerCount;
  }

  toApi() {
    return {
      patrolMarkers: this.patrolMarkers.map(x => x.toApi()),
      tableEdge: this.tableEdge,
      markerCount: this.markerCount,
    };
  }

  static fromApi(obj) {
    return new MarkerGroup(obj.patrolMarkers.map(x => PatrolMarker.fromApi(x)), obj.tableEdge, obj.markerCount);
  }
}
